import { axiosInstance } from "../../utils/axios-instance";
import {toast} from 'react-toastify';


export const deleteTokens = async () => {
    // const dispatch = useDispatch();
    if (localStorage.getItem("accessToken")) {
        localStorage.clear();
    }

    try {
        await axiosInstance({
            method: "get",
            url: "/sign-out"
        });
        toast.success('Successfully Signed Out', {type: "success", isLoading: false, theme: "colored", autoClose: "3500", containerId:"root"})
        // toast.update(ToastID.current , {render: `Successfully Signed In`, type: "success", isLoading: false, theme: "colored"})
    } catch (error) {
        console.error(error);
        toast.success('Error Signing Out', {type: "error", isLoading: false, theme: "colored", autoClose: "3500", containerId:"root"})
    }
    return true;
    // dispatch(resetSignIn());
    // dispatch(resetJobData());
    // dispatch(resetApplications());
};
